<template>
  <original-slider
    :marks="marks"
    :show-stops="false"
    :show-tooltip="false"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot></slot>
  </original-slider>
</template>

<script>
import { Slider } from 'element-ui'
/**
 * Basé principalement sur le [slider Element](https://element.eleme.io/#/fr-FR/component/slider)
 * @link https://element.eleme.io/#/fr-FR/component/slider
 */
export default {
  name: 'UbiSlider',
  components: { OriginalSlider: Slider },
  computed: {
    marks () {
      const marks = {}

      if (this.$attrs.min !== undefined) {
        marks[this.$attrs.min] = {
          style: {
            transform: 'translateX(0)'
          },
          label: String(
            this.$attrs['format-tooltip']
              ? this.$attrs['format-tooltip'](this.$attrs.min)
              : this.$attrs.min
          )
        }
      }

      if (this.$attrs.max !== undefined) {
        marks[this.$attrs.max] = {
          style: {
            transform: 'translateX(-100%)'
          },
          label: String(
            this.$attrs['format-tooltip']
              ? this.$attrs['format-tooltip'](this.$attrs.max)
              : this.$attrs.max
          )
        }
      }

      return marks
    }
  }
}
</script>
